export const InformationType = {
  "40YardDash": "40 Yard dash",
};

export const StageTypes = {
  20: "20",
};
